/* eslint-disable no-unused-expressions */
import { createAction, handleActions } from "redux-actions";
import { Map } from "immutable";

export const actions = {
  SET_NODES_CHANNELS: createAction("CHANNELS/SET"),
  CHANGE_NODES_CHANNELS_STATUS: createAction("CHANNELS/CHANGE/STATUS"),
  CLEAR_NODES_CHANNELS: createAction("CHANNELS/CLEAR"),
};

const defaultState = new Map({});

const getOutputs = (channelConfig) => {
  const outputsConfigArray = [];
  const outputsNamesArray = [];

  const hasNonmuxedOutputs = channelConfig?.nonMuxedOutputs && channelConfig?.nonMuxedOutputs.length > 0;
  const hasMuxedOutputs = channelConfig?.muxedOutputs && channelConfig?.muxedOutputs.length > 0;

  if (hasNonmuxedOutputs) {
    channelConfig?.nonMuxedOutputs.forEach((nonMuxedOutput) => {
      outputsConfigArray.push(nonMuxedOutput);
      outputsNamesArray.push(nonMuxedOutput.outputName);
    });
  }

  if (hasMuxedOutputs) {
    channelConfig?.muxedOutputs.forEach((muxedOutput) => {
      outputsConfigArray.push(muxedOutput);
      outputsNamesArray.push(muxedOutput?.name || muxedOutput?.outputName);

      if (muxedOutput?.outputs && muxedOutput?.outputs.length > 0) {
        muxedOutput?.outputs.forEach((muxedOutputOutput) => {
          outputsConfigArray.push(muxedOutputOutput);
          outputsNamesArray.push(muxedOutputOutput?.outputName);
        });
      }
    });
  }

  return { outputsConfigs: outputsConfigArray, outputsNames: outputsNamesArray };
};

const getCodecs = (channelConfig) => {
  const hasMuxedOutputs = channelConfig?.muxedOutputs && channelConfig?.muxedOutputs.length > 0;
  const codecsConfig = {};

  if (hasMuxedOutputs) {
    channelConfig?.muxedOutputs.forEach((muxedOutput) => {
      if (muxedOutput.muxer) {
        codecsConfig[muxedOutput.outputId] = {
          ...codecsConfig[muxedOutput.outputId],
          name: muxedOutput?.name,
          programs: muxedOutput?.muxer?.programs,
        };
      }
    });
  }

  return codecsConfig;
};

const reducer = handleActions(
  {
    [actions.SET_NODES_CHANNELS]: (state, { payload }) => {
      const parsedPayload = payload
        .map((channel) => ({
          [channel.channelId]: { ...channel, outputs: getOutputs(channel.config), codecs: getCodecs(channel.config) },
        }))
        .reduce((prev, next) => ({ ...prev, ...next }), {});

      return new Map({ ...parsedPayload });
    },
    [actions.CHANGE_NODES_CHANNELS_STATUS]: (state, { payload, payload: { channelId } }) => {
      const channelExist = state.get(`${channelId}`);
      if (!channelExist) {
        return state;
      }

      return state.update(`${channelId}`, (value) => {
        return {
          ...value,
          status: payload,
        };
      });
    },
    [actions.CLEAR_NODES_CHANNELS]: () => defaultState,
  },
  defaultState
);

export const selectors = {
  getChannels: (state) => state.get("nodeChannels"),
  getChannelCodecs: ({ state, channelId }) => {
    const filteredChannel = state.get("nodeChannels").find((channel) => +channel.channelId === +channelId);

    return filteredChannel && filteredChannel?.codecs;
  },
  numberOfChannels: (state) => state.get("nodeChannels").size,
};

export default reducer;
